interface DeleteConfirmModalProps {
  deleteTarget: {
    type: 'authority' | 'service';
    id: string;
    name: string;
  } | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function DeleteConfirmModal({
  deleteTarget,
  isDeleting,
  onClose,
  onConfirm,
}: DeleteConfirmModalProps) {
  if (!deleteTarget) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md overflow-hidden rounded-xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-3 text-red-600">
          <h3 className="text-base font-semibold text-gray-900">
            Delete {deleteTarget.type === 'authority' ? 'Authority' : 'Service'}
          </h3>
        </div>

        <p className="mt-3 text-sm text-gray-600">
          Are you sure you want to delete <span className="font-semibold text-gray-900">"{deleteTarget.name}"</span>?
          {deleteTarget.type === 'authority' && (
            <span className="block mt-1 text-xs text-red-500">
              Warning: All associated services under this authority will also be deleted!
            </span>
          )}
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700 disabled:opacity-50"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
